<template>
<v-container v-if="tournament">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{tournament.title}} </div>
      </v-col>
    </v-row>
    <v-row>
    <v-col v-if="tournament.club">
      <div>Club: {{tournament.club.name}}</div>
    </v-col>
  </v-row>
  </div>
<div>
  <br>
  <div v-if="!exist_rut" class="red-background text-center">Temporalmente solo jugadores existentes podran inscribirse online</div>
      <div v-if="exist_rut" class="red-background text-center">Jugador existente solo ingrese el correo para inscribirse </div>

<br>
  <v-row>
    <v-col cols="12" md="4">
      <v-text-field
      label="Rut"
      v-model="inscription.identificator"
      :rules="rutRules"
      v-debounce:1s="performId"
      required
      ></v-text-field>
    </v-col>
    <v-col v-if="false" cols="12" md="4" >
      <v-text-field
      label="Nombre"
      v-model="inscription.first_name"
      :rules="nameRules"
      required
    ></v-text-field>
    </v-col>
      <v-col v-if="false" cols="12" md="4">
      <v-text-field
      label="Segundo Nombre"
      v-model="inscription.second_name"
      :rules="nameRules"
    ></v-text-field>
    </v-col>
      <v-col v-if="false" cols="12" md="4">
      <v-text-field
      label="Apellido Paterno"
      v-model="inscription.last_name"
      :rules="nameRules"
      required
    ></v-text-field>
    </v-col>
      <v-col v-if="false" cols="12" md="4">
      <v-text-field
      label="Apellido Materno"
      v-model="inscription.last_name_second"
      :rules="nameRules"
    ></v-text-field>
    </v-col>
    <v-col v-if="false" cols="12" md="4">
      <v-text-field label="Fecha Nacimiento dd/mm/yyyy" v-model="inscription.birthday" :rules="dateRules"></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
      label="Email"
      v-model="inscription.email"
      :rules="emailRules"
      required
    ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-btn @click="guardar" color="primary" :disabled="!exist_rut">Guardar</v-btn>
    </v-col>
  </v-row>
  </div>
</v-container>

</template>
<script>


import gql from "graphql-tag";
import axios from "axios";
import {vue3Debounce} from "vue-debounce";

export default {
  directives: {
    debounce: vue3Debounce({ lock: true })
  },
  apollo: {
    tournament: {query: gql` query($id:String!){
       tournament(id:$id){
        title
        type
        address
        club {
          name
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
    players: {query: gql`  query($identificator:String!){
       players(identificator:$identificator){
        id
      }
    }`,
      variables() {return {"identificator" :this.rut}}

    },
  },
  props:['id'],
    name:"SeeNewsChess",
  data() {

    return {
      exist_rut: false,
      players:[],
      rut:'',
      tournament: null,
      inscription:{
        identificator:'',
        birthday:'',
        email:'',
        first_name:'',
        second_name:'',
        last_name:'',
        last_name_second:'',
      },
      rutRules: [
      v => !!v || 'El RUT es requerido',
      v => this.isValidRUT(v) || 'El RUT es inválido',
    ],
      emailRules: [
      v => !!v || 'E-mail es requerido',
      v => /.+@.+\..+/.test(v) || 'E-mail debe ser válido',
    ],
      dateRules: [
      v => !!v || 'La fecha es requerida',
      v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(v) || 'La fecha debe estar en formato dd/mm/yyyy',
    ],
      nameRules: [
  v => !!v || 'El campo es requerido',
  v => (/^[A-Za-zñÑáéíóúÁÉÍÓÚüÜ\s'-]+$/).test(v) || 'El campo es inválido',
],
      nameRulesNR: [
      v => (/^[A-Za-zñÑáéíóúÁÉÍÓÚüÜ\s'-]+$/).test(v) || 'El campo es inválido',
    ],
    }
  },
  methods: {
    performId(newVal,type ) {
      console.log('debounced', newVal, type)
      this.rut = newVal;
    },
    guardar(){
      const url = '/create_model_inscription/'; // URL de tu endpoint POST
      this.inscription.tournament_id = this.id
      this.$recaptcha('submit_form')
      .then((token) => {
        this.inscription.token = token
        axios.post(url, this.inscription).then(() => {
        window.location.href = "/inscritos/" + this.id
      })
      .catch(error => {
        alert(error.response.data.message)
        console.log(error)
      })
      })
      .catch((error) => {
        console.log("erorrr", error)
        alert(error.response.data.message)
        // Manejar cualquier error que ocurra durante la ejecución de la promesa
      });

    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    isValidRUT(input) {
      let rut = input.replace(/\./g,'');
      rut = rut.replace('-','');
      let body = rut.slice(0,-1);
      let dv = rut.slice(-1).toUpperCase();
      let total = 0;
      let factor = 2;

      for(let i = body.length - 1; i >= 0; i--) {
        total += body.charAt(i) * factor;
        factor = (factor === 7) ? 2 : factor + 1;
      }

      let remainder = total % 11;
      let key = 11 - remainder;

      if (key === 11) key = 0;
      if (key === 10) key = "K";

      return key.toString() === dv;
    },
  },
  watch:{
    'players'(val){
      console.log("plauers",val, val.length)
      if(val.length > 0){
        this.exist_rut = true;
      } else {
        this.exist_rut = false;
      }
    },
  }
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
.red-background {
  background-color: coral;
}
</style>
